import React from "react";
import { useSelector } from "react-redux";

import PostCard from "./PostCard";

export default function Posts() {
  const posts = useSelector((state) =>
    state.posts?.posts
      ?.filter(
        (post) =>
          post.status === "published" &&
          post.slug !== "gioi-thieu" &&
          post.slug !== "dieu-khoan"
      )
      ?.filter((e) => e.type !== "notification")
  );

  return (
    <div className="container mx-auto pt-1">
      <div>
        {posts?.slice(0, 16)?.map((article) => (
          <div key={article.id} className="px-2">
            <PostCard article={article} />
          </div>
        ))}
      </div>
    </div>
  );
}
